import type { IconData } from '@stacksjs/iconify-core'

export const minusSquareFull: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17 13H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2\"/><path fill=\"currentColor\" d=\"M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-4 11H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default minusSquareFull
